import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import * as XLSX from 'xlsx';

const InvoiceReport = () => {
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedDate, setSelectedDate] = useState("");
    const [getData, setGetData] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    console.log("get data", getData);

    useEffect(() => {
        const fetchInvoiceData = async () => {
            try {
                const response = await axios.get('https://api.trucoo.in/invoice/invoice/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-KEY': 'erpTrucoo'
                    }
                });
                if (response.data.status === 'success') {
                    setGetData(response.data.data || []);
                }
            } catch (error) {
                console.error("Error fetching invoice data:", error);
            }
        };

        const fetchProductData = async () => {
            try {
                const response = await axios.get('https://api.trucoo.in/product/allproduct/');
                setAllProducts(response.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchInvoiceData();
        fetchProductData();
    }, []);
    
    const currentYear = new Date().getFullYear();
    const filteredData = getData.filter(order => {
        const orderDate = new Date(order.date);
        return (
            orderDate.getFullYear() === currentYear &&
            orderDate.getMonth() + 1 === selectedMonth &&
            (selectedDate === "" || orderDate.toLocaleDateString('en-CA') === selectedDate)
        );
    });

    const groupedData = {};
    const totalProducts = {};
    const dealerTotalProducts = {};

    allProducts.forEach(product => {
        totalProducts[product.productName] = 0;
    });

    filteredData.forEach(order => {
        const dealer = order.dealerData?.routes || "Unknown Dealer";

    
        if (!groupedData[dealer]) {
            groupedData[dealer] = {};
            dealerTotalProducts[dealer] = 0;
            allProducts.forEach(product => {
                groupedData[dealer][product.productName] = 0;
            });
        }

        if (Array.isArray(order.orderData)) {
            order.orderData.forEach(item => {
                if (groupedData[dealer][item.itemName] !== undefined) {
                    groupedData[dealer][item.itemName] += parseFloat(item.qty) || 0;
                    totalProducts[item.itemName] += parseFloat(item.qty) || 0;
                    dealerTotalProducts[dealer] += parseFloat(item.qty) || 0;
                }
             });
        }
    });

    // console.log("grouped data",groupedData)
    // console.log("total products",totalProducts)
    // console.log("dealterproduct quantity",dealerTotalProducts) 

    const downloadExcel = () => {
            const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
            XLSX.writeFile(wb, 'Dealer_Invoice_Report.xlsx');
        };

    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Invoice Report</h4>
                                <p className="mb-0 box-subtitle">Dealers Invoice Report</p>
                                
                            </div>
                            <div className="box-body">
                                <div class="row">
                            <div className="col-lg-3 mb-3">
                                    <select 
                                        value={selectedMonth} 
                                        onChange={(e) => setSelectedMonth(Number(e.target.value))} 
                                        className="border p-2"
                                    >
                                        {[...Array(12)].map((_, i) => (
                                            <option key={i + 1} value={i + 1}>{new Date(0, i).toLocaleString('en', { month: 'long' })}</option>
                                        ))}
                                    </select>
                                    <input 
                                        type="date" 
                                        value={selectedDate} 
                                        onChange={(e) => setSelectedDate(e.target.value)} 
                                        className="border p-2" 
                                    />
                                </div>
                                {/* <p>{selectedDate}</p> */}

                               
                                <div className="col-lg-9 mb-3" align="right">
                                        <button onClick={downloadExcel} className="btn btn-primary"> Download Excel </button>
                                    </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered" id='printableArea'>
                                        <thead>
                                            <tr  className="fw-400 text-gray-600  fs-10">
                                                <th>Route/Item</th>
                                                {allProducts.map(product => (
                                                    <th key={product.productName}>{product.productName}</th>
                                                ))}
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.entries(groupedData).map(([dealer, products]) => (
                                                <tr key={dealer}  className="fw-400 text-gray-600  fs-10">
                                                    <td>{dealer}</td>
                                                    {allProducts.map(product => (
                                                        <th key={product.productName}>{parseFloat(products[product.productName] || 0).toFixed(2)}</th>
                                                    ))}
                                                    <th>{parseFloat(dealerTotalProducts[dealer] || 0).toFixed(2)}</th> 
                                                </tr>
                                            ))}
                                            <tr  className="fw-400 text-gray-600  fs-10">
                                                <th>Total</th>
                                                {allProducts.map(product => (
                                                    <th key={product.productName}>{parseFloat(totalProducts[product.productName] || 0).toFixed(2)}</th>
                                                ))}
                                                <th>{(Object.values(dealerTotalProducts).reduce((acc, val) => acc + val, 0)).toFixed(2)}</th>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default InvoiceReport;
